import { Component, ElementRef, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base} from '../base/base';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import Swal from "sweetalert2";
import {NotificationsComponent} from '../notifications/notifications.component';
@Component({
  selector: 'app-edit-document-vehicle',
  templateUrl: './edit-document-vehicle.component.html',
  styleUrls: ['./edit-document-vehicle.component.css']
})
export class EditDocumentVehicleComponent extends Base {
  isReject: boolean = false;
  public vehicleForm: FormGroup;
  loading: boolean = false;
  @ViewChild('inputFileEnrollmentFront') inputFileEnrollmentFront: ElementRef;
  @ViewChild('inputFileEnrollmentBack') inputFileEnrollmentBack: ElementRef;
  @ViewChild('inputFileTechnomechanicsFront') inputFileTechnomechanicsFront: ElementRef;
  @ViewChild('inputFileTechnomechanicsBack') inputFileTechnomechanicsBack: ElementRef;
  @ViewChild('inputFileSoat') inputFileSoat: ElementRef;
  imageLicenseFront = '';
  imageLicenseBack = '';
  imageIdentifyFront = '';
  imageIdentifyBack = '';
  imageSoat = '';
  public url_base = this.URL_BASE;
  modelTecno: NgbDateStruct;
  modelSoat: NgbDateStruct;
  @Input() public data;
  @Input() public action;

  constructor(injector: Injector,
              private form: FormBuilder,
              private router: Router,
              private NgxSpinner: NgxSpinnerService,
              private apis: ApisService,
              private notification: NotificationsComponent) {
      super(injector);
  }

  ngOnInit() {
    console.log('llego data (this.data, this.action) :: ', this.data, this.action);
    this.modelSoat = {
      "year": parseInt(this.data.date_soat.split(['-'])[0]),
      "month": parseInt(this.data.date_soat.split(['-'])[1]),
      "day": parseInt(this.data.date_soat.split(['-'])[2].split(' ')[0])
    }

    this.modelTecno= {
      "year": parseInt(this.data.date_tecno.split(['-'])[0]),
      "month": parseInt(this.data.date_tecno.split(['-'])[1]),
      "day": parseInt(this.data.date_tecno.split(['-'])[2].split(' ')[0])
    }

    this.vehicleForm = this.form.group({
      license_plate: [this.data['license_plate'], {validators: [Validators.required]}],
      date_soat: [this.data['date_soat'], {validators: [Validators.required]}],
      date_tecno: [this.data['date_tecno'], {validators: [Validators.required]}],
    });
  }

  onSubmit() {
    const form = this.vehicleForm.value;
    if (this.data && this.data.vehicle_id && form && form.date_soat && form.date_tecno && form.license_plate) {
      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de que quieres actualizar la información?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.loading = true;
          form['vehicle_id'] = this.data.vehicle_id;
          this.apis.updateInfoVehicle(form).then(result => {
            if (result['status'] == 'success') {
              this.loading = false;
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          });
        }
      })
    } else {
      this.notification.showNotification('bottom', 'left', 'error', 'Error en la información.');
    }
  }



  handleInputChange(image, name) {
    let file = image.target.files[0];
    let context = this;
    var reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      switch (name) {
        case 'enrollment_front':
          context.imageLicenseFront = reader.result.split(',')[1];
          break;
        case 'enrollment_back':
          context.imageLicenseBack = reader.result.split(',')[1];
          break;
        case 'technomechanics_front':
          context.imageIdentifyFront = reader.result.split(',')[1];
          break;
        case 'technomechanics_back':
          context.imageIdentifyBack = reader.result.split(',')[1];
          break;
        case 'soat':
          context.imageSoat = reader.result.split(',')[1];
          break;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  saveImagen(name) {
    if (this.data && this.data.vehicle_id) {
      let image = '';
      let imageOld = '';
      switch (name) {
        case 'enrollment_front':
          image = this.imageLicenseFront;
          imageOld = this.data.enrollment_front;
          break;
        case 'enrollment_back':
          image = this.imageLicenseBack;
          imageOld = this.data.enrollment_back;
          break;
        case 'technomechanics_front':
          image = this.imageIdentifyFront;
          imageOld = this.data.identify_front;
          break;
        case 'technomechanics_back':
          image = this.imageIdentifyBack;
          imageOld = this.data.identify_back;
          break;
        case 'soat':
          image = this.imageSoat;
          imageOld = this.data.soat;
          break;
      }
      let data = {
        vehicle_id: this.data.vehicle_id,
        name: name,
        image: image,
        imageOld: imageOld
      };

      this.apis.updateImageDocumentsVehicle(data).then(result => {
        if (result['status'] == 'success') {
          this.data[name] = result['data'][name];
        }
      });
    }
  }

  resetInputFile(event, name) {
    console.log('reset ', event);
    switch (name) {
      case 'enrollment_front':
        this.inputFileEnrollmentFront.nativeElement.value = '';
        break;
      case 'enrollment_back':
        this.inputFileEnrollmentBack.nativeElement.value = '';
        break;
      case 'technomechanics_front':
        this.inputFileTechnomechanicsFront.nativeElement.value = '';
        break;
      case 'technomechanics_back':
        this.inputFileTechnomechanicsBack.nativeElement.value = '';
        break;
      case 'soat':
        this.inputFileSoat.nativeElement.value = '';
        break;
    }
  }
}
